import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=99891a1e&scoped=true"
import script from "./QuestionPreview.vue?vue&type=script&lang=js"
export * from "./QuestionPreview.vue?vue&type=script&lang=js"
import style0 from "./QuestionPreview.vue?vue&type=style&index=0&id=99891a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99891a1e",
  null
  
)

export default component.exports